// extracted by mini-css-extract-plugin
export default {"text":"Subtitle_text__t5COu"};